var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "26",
      "height": "26"
    }
  }, _vm.$listeners), [_c('circle', {
    attrs: {
      "cx": "13",
      "cy": "13",
      "r": "13",
      "fill": "#fff"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "d": "M18.98 17.08a.3.3 0 0 0 .02-.1.2.2 0 0 0-.04-.094.5.5 0 0 0-.119-.11l-2.589-1.631-.024-.008a.2.2 0 0 0-.052-.021 1 1 0 0 0-.132-.017.5.5 0 0 0-.183.018.5.5 0 0 0-.16.08l-.833.692v.002a.6.6 0 0 1-.249.116l-.089.018q-.067.011-.121.007l-.073-.01-.171-.043a1.7 1.7 0 0 1-.275-.1 4 4 0 0 1-.311-.155v-.001c-.616-.339-1.324-.933-1.943-1.586-.623-.658-1.165-1.385-1.438-1.98a3 3 0 0 1-.154-.38 2 2 0 0 1-.084-.355l-.004-.064a.6.6 0 0 1 .056-.203 1 1 0 0 1 .055-.104.5.5 0 0 1 .099-.11l.728-.597.001.001a.46.46 0 0 0 .152-.233.3.3 0 0 0 .013-.116.25.25 0 0 0-.03-.099l-.003-.008-1.313-2.713a.6.6 0 0 0-.127-.142.1.1 0 0 0-.04-.022A.2.2 0 0 0 9.49 7v.002a.2.2 0 0 0-.089.01.3.3 0 0 0-.098.059L7.327 8.688l-.015.012a.5.5 0 0 0-.082.075 1 1 0 0 0-.189.36l-.008.062-.023.183-.004.028-.002.03h.001v.011h-.002q-.006.09-.001.216.004.127.022.288c.178 1.743 1.61 4.091 3.516 5.969 1.703 1.678 3.772 2.965 5.634 3.073l.088.005h.056c.064-.003.04-.003.063-.004h.025a1.1 1.1 0 0 0 .406-.129.6.6 0 0 0 .092-.065l.015-.013 1.975-1.605a.3.3 0 0 0 .086-.104"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }